import { PATHS } from "@/lib/router";
import {
  TargetSettingsPage,
  TargetSummaryPage,
  EsgDashboardPage,
  ESGReportListPage,
  CustomDisclosureLibraryPage,
} from "./pages";
import { EsgForm } from "../onboarding";
import ESGReportPage from "./pages/ESGReportPage";

export const esgRoutes = [
  {
    path: PATHS.ESG_TARGETS,
    element: <TargetSettingsPage />,
  },
  {
    path: PATHS.ESG_DASHBOARD,
    element: <EsgDashboardPage />,
  },
  {
    path: PATHS.ESG_TARGETS_SUMMARY,
    element: <TargetSummaryPage />,
  },
  {
    path: PATHS.ESG_REPORTS,
    element: <ESGReportListPage />,
  },
  {
    path: PATHS.ESG_REPORT,
    element: <ESGReportPage />,
  },
  {
    path: PATHS.ESG_FRAMEWORKS,
    element: <EsgForm />,
  },
  {
    path: PATHS.ESG_CUSTOM_DISCLOSURES,
    element: <CustomDisclosureLibraryPage />,
  },
];
